import { css } from 'styled-components';
import { moreThan } from '@adecco/base-app/src/constants/breakpoints/breakpoints';

export const grid_1_2_3 = css`
  display: grid;

  ${moreThan('md')} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${moreThan('lg')} {
    grid-template-columns: repeat(3, 1fr);
  }
`;
